import React from "react";
import Image from "next/image";
import styles from "./ProgrammeWhyRegenesys.module.css";

interface WhyRegenesysItemImage {
  id?: number;
  documentId?: string;
  alternativeText?: string | null;
  url: string;
}

interface WhyRegenesysItem {
  id: number;
  title: string;
  image?: WhyRegenesysItemImage;
}

interface WhyRegenesysSectionData {
  id?: number;
  title: string;
  description?: string;
  hide_section?: boolean;
  items?: WhyRegenesysItem[];
}

interface ProgrammeWhyRegenesysProps {
  data?: WhyRegenesysSectionData;
}

const ProgrammeWhyRegenesys: React.FC<ProgrammeWhyRegenesysProps> = ({
  data,
}) => {
  // Hide section if hide_section is true
  if (!data || data.hide_section === true) {
    return null;
  }

  const { title, description, items } = data;

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className={styles.whyRegenesysSection}>
      <div className="container">
        <h2 className={styles.sectionTitle}>{title}</h2>
        {description && (
          <p className={styles.introduction}>{description}</p>
        )}

        {/* Desktop Version */}
        <div className={styles.desktopFeatures}>
          <div className={styles.featuresGrid}>
            {items.map((item) => (
              <div key={item.id} className={styles.featureCard}>
                {item.image?.url && (
                  <div className={styles.iconWrapper}>
                    <Image
                      src={item.image.url}
                      alt={
                        item.image.alternativeText ||
                        item.title ||
                        "Why Regenesys"
                      }
                      width={32}
                      height={32}
                      className={styles.featureIcon}
                    />
                  </div>
                )}
                <p className={styles.featureDescription}>{item.title}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile Version */}
        <div className={styles.mobileFeatures}>
          {items.map((item) => (
            <div key={item.id} className={styles.featureCard}>
              {item.image?.url && (
                <div className={styles.iconWrapper}>
                  <Image
                    src={item.image.url}
                    alt={
                      item.image.alternativeText ||
                      item.title ||
                      "Why Regenesys"
                    }
                    width={32}
                    height={32}
                    className={styles.featureIcon}
                  />
                </div>
              )}
              <p className={styles.featureDescription}>{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgrammeWhyRegenesys;

